// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_proxy.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AppEntitlementsProxySearch } from "./app_entitlement_proxy";
import type { GetAncestorEntitlementsRequest } from "./app_entitlement_proxy";
import type { EntitlementChainResponse } from "./app_entitlement_proxy";
import type { GetChildEntitlementsRequest } from "./app_entitlement_proxy";
import type { SearchAppEntitlementProxyBindingsResponse } from "./app_entitlement_proxy";
import type { SearchAppEntitlementProxyBindingsRequest } from "./app_entitlement_proxy";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { AppEntitlementsProxy } from "./app_entitlement_proxy";
import type { DisableAppEntitlementProxyResponse } from "./app_entitlement_proxy";
import type { DisableAppEntitlementProxyRequest } from "./app_entitlement_proxy";
import type { EnableAppEntitlementProxyResponse } from "./app_entitlement_proxy";
import type { EnableAppEntitlementProxyRequest } from "./app_entitlement_proxy";
import type { GetAppEntitlementProxyResponse } from "./app_entitlement_proxy";
import type { GetAppEntitlementProxyRequest } from "./app_entitlement_proxy";
import type { DeleteAppEntitlementProxyResponse } from "./app_entitlement_proxy";
import type { DeleteAppEntitlementProxyRequest } from "./app_entitlement_proxy";
import type { CreateAppEntitlementProxyResponse } from "./app_entitlement_proxy";
import type { CreateAppEntitlementProxyRequest } from "./app_entitlement_proxy";
import type { BulkCreateAppEntitlementProxyWithDestinationsResponse } from "./app_entitlement_proxy";
import type { BulkCreateAppEntitlementProxyWithDestinationsRequest } from "./app_entitlement_proxy";
import type { ListAppEntitlementProxyDestinationsRequest } from "./app_entitlement_proxy";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { ListAppEntitlementsProxyResponse } from "./app_entitlement_proxy";
import type { ListAppEntitlementProxySourcesRequest } from "./app_entitlement_proxy";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlementsProxy
 */
export interface IAppEntitlementsProxyClient {
    /**
     * @generated from protobuf rpc: ListSources
     */
    listSources(input: ListAppEntitlementProxySourcesRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementProxySourcesRequest, ListAppEntitlementsProxyResponse>;
    /**
     * @generated from protobuf rpc: ListDestinations
     */
    listDestinations(input: ListAppEntitlementProxyDestinationsRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementProxyDestinationsRequest, ListAppEntitlementsProxyResponse>;
    /**
     * @generated from protobuf rpc: BulkCreateAppEntitlementProxyWithDestinations
     */
    bulkCreateAppEntitlementProxyWithDestinations(input: BulkCreateAppEntitlementProxyWithDestinationsRequest, options?: RpcOptions): UnaryCall<BulkCreateAppEntitlementProxyWithDestinationsRequest, BulkCreateAppEntitlementProxyWithDestinationsResponse>;
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: CreateAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<CreateAppEntitlementProxyRequest, CreateAppEntitlementProxyResponse>;
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<DeleteAppEntitlementProxyRequest, DeleteAppEntitlementProxyResponse>;
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: GetAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<GetAppEntitlementProxyRequest, GetAppEntitlementProxyResponse>;
    /**
     * @generated from protobuf rpc: Enable
     */
    enable(input: EnableAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<EnableAppEntitlementProxyRequest, EnableAppEntitlementProxyResponse>;
    /**
     * @generated from protobuf rpc: Disable
     */
    disable(input: DisableAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<DisableAppEntitlementProxyRequest, DisableAppEntitlementProxyResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlementsProxy
 */
export class AppEntitlementsProxyClient implements IAppEntitlementsProxyClient, ServiceInfo {
    typeName = AppEntitlementsProxy.typeName;
    methods = AppEntitlementsProxy.methods;
    options = AppEntitlementsProxy.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: ListSources
     */
    listSources(input: ListAppEntitlementProxySourcesRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementProxySourcesRequest, ListAppEntitlementsProxyResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppEntitlementProxySourcesRequest, ListAppEntitlementsProxyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListDestinations
     */
    listDestinations(input: ListAppEntitlementProxyDestinationsRequest, options?: RpcOptions): UnaryCall<ListAppEntitlementProxyDestinationsRequest, ListAppEntitlementsProxyResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAppEntitlementProxyDestinationsRequest, ListAppEntitlementsProxyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkCreateAppEntitlementProxyWithDestinations
     */
    bulkCreateAppEntitlementProxyWithDestinations(input: BulkCreateAppEntitlementProxyWithDestinationsRequest, options?: RpcOptions): UnaryCall<BulkCreateAppEntitlementProxyWithDestinationsRequest, BulkCreateAppEntitlementProxyWithDestinationsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkCreateAppEntitlementProxyWithDestinationsRequest, BulkCreateAppEntitlementProxyWithDestinationsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Create
     */
    create(input: CreateAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<CreateAppEntitlementProxyRequest, CreateAppEntitlementProxyResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAppEntitlementProxyRequest, CreateAppEntitlementProxyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Delete
     */
    delete(input: DeleteAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<DeleteAppEntitlementProxyRequest, DeleteAppEntitlementProxyResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAppEntitlementProxyRequest, DeleteAppEntitlementProxyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Get
     */
    get(input: GetAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<GetAppEntitlementProxyRequest, GetAppEntitlementProxyResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAppEntitlementProxyRequest, GetAppEntitlementProxyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Enable
     */
    enable(input: EnableAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<EnableAppEntitlementProxyRequest, EnableAppEntitlementProxyResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<EnableAppEntitlementProxyRequest, EnableAppEntitlementProxyResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Disable
     */
    disable(input: DisableAppEntitlementProxyRequest, options?: RpcOptions): UnaryCall<DisableAppEntitlementProxyRequest, DisableAppEntitlementProxyResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<DisableAppEntitlementProxyRequest, DisableAppEntitlementProxyResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlementsProxySearch
 */
export interface IAppEntitlementsProxySearchClient {
    /**
     * @generated from protobuf rpc: SearchAppEntitlementProxyBindings
     */
    searchAppEntitlementProxyBindings(input: SearchAppEntitlementProxyBindingsRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementProxyBindingsRequest, SearchAppEntitlementProxyBindingsResponse>;
    /**
     * @generated from protobuf rpc: GetChildEntitlements
     */
    getChildEntitlements(input: GetChildEntitlementsRequest, options?: RpcOptions): UnaryCall<GetChildEntitlementsRequest, EntitlementChainResponse>;
    /**
     * @generated from protobuf rpc: GetAncestorEntitlements
     */
    getAncestorEntitlements(input: GetAncestorEntitlementsRequest, options?: RpcOptions): UnaryCall<GetAncestorEntitlementsRequest, EntitlementChainResponse>;
}
/**
 * @generated from protobuf service c1.api.app.v1.AppEntitlementsProxySearch
 */
export class AppEntitlementsProxySearchClient implements IAppEntitlementsProxySearchClient, ServiceInfo {
    typeName = AppEntitlementsProxySearch.typeName;
    methods = AppEntitlementsProxySearch.methods;
    options = AppEntitlementsProxySearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: SearchAppEntitlementProxyBindings
     */
    searchAppEntitlementProxyBindings(input: SearchAppEntitlementProxyBindingsRequest, options?: RpcOptions): UnaryCall<SearchAppEntitlementProxyBindingsRequest, SearchAppEntitlementProxyBindingsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAppEntitlementProxyBindingsRequest, SearchAppEntitlementProxyBindingsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetChildEntitlements
     */
    getChildEntitlements(input: GetChildEntitlementsRequest, options?: RpcOptions): UnaryCall<GetChildEntitlementsRequest, EntitlementChainResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetChildEntitlementsRequest, EntitlementChainResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAncestorEntitlements
     */
    getAncestorEntitlements(input: GetAncestorEntitlementsRequest, options?: RpcOptions): UnaryCall<GetAncestorEntitlementsRequest, EntitlementChainResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAncestorEntitlementsRequest, EntitlementChainResponse>("unary", this._transport, method, opt, input);
    }
}
